import { RepositoryEngineeringInsightsPage } from '@internal/backstage-plugin-engineering-insights';
import { EntityGithubInsightsContent } from '@roadiehq/backstage-plugin-github-insights';
import { EntityGithubPullRequestsContent } from '@roadiehq/backstage-plugin-github-pull-requests';
import React from 'react';

import {
  EntityAdrContent,
  isAdrAvailable,
} from '@backstage-community/plugin-adr';
import { EntityLayout } from '@backstage/plugin-catalog';

import { Grid } from '@material-ui/core';

import {
  TechDocsContent,
  CICDContent,
  RepositoryOverviewContent,
} from '../Content';
import {
  isGitHubAvailable,
  isGithubPullRequestsAvailable,
} from '../entityUtils';

export const RepositoryEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {RepositoryOverviewContent}
    </EntityLayout.Route>
    <EntityLayout.Route
      if={isGitHubAvailable}
      path="/code-insights"
      title="Code Insights"
    >
      <EntityGithubInsightsContent />
    </EntityLayout.Route>
    <EntityLayout.Route
      if={isGithubPullRequestsAvailable}
      path="/pull-requests"
      title="Pull Requests"
    >
      <EntityGithubPullRequestsContent />
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/engineering-insights"
      title="Engineering Insights"
    >
      <Grid item sm={12}>
        <RepositoryEngineeringInsightsPage />
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/ci-cd" title="CI/CD">
      {CICDContent}
    </EntityLayout.Route>

    <EntityLayout.Route if={isAdrAvailable} path="/adrs" title="ADRs">
      <EntityAdrContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {TechDocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
